<template>
  <div class="question-item">
    <div class="question-title">
      <div class="left">{{ index + 1 }}、{{ question.taspq_title }}</div>
      <span v-if="question.taspq_require==10" class="required">*</span>
      <span v-if="taspq_type" class="question-type">{{ $t(quesType[taspq_type]) }}</span>
    </div>
    
    <!-- 单选题 -->
    <div class="options-list" v-if="taspq_type === 10">
      <div 
        v-for="(option, oIndex) in question.taspq_options" 
        :key="oIndex"
        class="option-item"
        @click="handleRadioClick(option,oIndex)">
        <i class="selbtn dis" v-if="question.is_submit==10" :class="{'ckd': value.value === oIndex}"></i>
        <i class="selbtn" v-else :class="{'ckd': value.value === oIndex}"></i>
        <span class="option-text">{{ option.title }}</span>
      </div>
    </div>
    
    <!-- 多选题 -->
    <div class="options-list" v-else-if="taspq_type === 20">
      <div 
        v-for="(option, oIndex) in question.taspq_options" 
        :key="oIndex"
        class="option-item"
        @click="handleCheckboxClick(option,oIndex)">
        <i class="selbtn2 dis" v-if="question.is_submit==10" :class="{'iconfont icon-duigou ckd': isSelected(oIndex)}"></i>
        <i class="selbtn2" v-else :class="{'iconfont icon-duigou ckd': isSelected(oIndex)}"></i>
        <span class="option-text">{{ option.title }}</span>
      </div>
    </div>

    <!-- 评分题 -->
    <div class="options-list" v-if="taspq_type === 30">
      <div 
        v-for="(option, oIndex) in question.taspq_options" 
        :key="oIndex"
        class="option-item">
        <span class="option-text">{{ option.title }}：</span>
        <div class="score-box">
          <span class="score-label">{{ option.score_min_title }}</span>
          <el-rate 
            v-model="value[oIndex].title" 
            :disabled="question.is_submit==10"
            :min="option.score_min" 
            :max="option.score_max" 
            @change="handleScoreChange(oIndex)"></el-rate>
          <span class="score-label">{{ option.score_max_title }}</span>
        </div>
      </div>
    </div>
    
    <!-- 简答题 -->
    <div class="options-list" v-else-if="taspq_type === 40">
      <el-input 
        type="textarea" 
        :disabled="question.is_submit==10"
        :value="value.title" 
        @input="updateText"
        :rows="5"
        :maxlength="500"
        show-word-limit
        :placeholder="$t('请输入您的回答')">
      </el-input>
    </div>
  </div>
</template>

<script>
import { min } from 'lodash';

export default {
  name: 'QuestionItem',
  props: {
    question: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    taspq_type: {
      type: Number,
      required: true,
    },
    taspq_id: {
      type: Number,
      required: false,
    },
    value: {
      type: [Array,Object],
      default: null
    }
  },
  data(){
    return {
      quesType: {
        10: '单选',
        20: '多选',
        30: '评分',
        40: '简答'
      }
    }
  },
  methods: {
    handleRadioClick(option,oIndex) {
      if(this.question.is_submit==10) return;
      this.$emit('select', this.index, oIndex, option);
    },
    handleCheckboxClick(option,oIndex) {
      if(this.question.is_submit==10) return;
      this.$emit('multiSelect', this.index, oIndex, option,this.taspq_id);
    },
    isSelected(oIndex) {
      return this.value.some(item => item.value == oIndex)
    },
    updateText(text) {
      this.$emit('update:text', this.index, text);
    },
    handleScoreChange(oIndex) {
      this.$emit('update:score', this.index, oIndex, this.value[oIndex].title);
    }
  }
};
</script>

<style lang="scss" scoped>
.question-item {
  margin-bottom: 16px;
  &:last-child{
    margin-bottom: 0;
  }
  .question-title {
    margin-bottom: 12px;
    line-height: 32px;
    display: flex;
    .left{
      font-weight: 700;
    }
    .question-type{
      border-radius: 4px;
      margin-top: 4px;
      padding: 0 8px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      background-color: #F5F6F8;
      margin-left: 10px;
    }
    .required {
      color: #e0242b;
      margin-left: 5px;
    }
  }
  
  .options-list {
    .option-item {
      margin-bottom: 12px;
      line-height: 22px;
      display: flex;
      align-items: flex-start;
      cursor: pointer;
      user-select: none;
      &:last-child{
        margin-bottom: 0;
      }
      .selbtn{
        margin: 5px 10px 0 0;
        width: 14px;
        height: 14px;
        border-radius: 50%;	
        border: 1px solid #595959;
        &.ckd{
          border: 4px solid #2673E5;
        }
        &.dis{
          border: 1px solid #aaaaaa;
        }
        &.ckd.dis{
          border: 4px solid #aaaaaa;
        }
      }
      .selbtn2{
        margin: 5px 10px 0 0;
        width: 14px;
        height: 14px;
        font-size: 12px;
        text-align: center;
        line-height: 12px;
        border-radius: 3px;	
        border: 1px solid #595995;
        &.ckd{
          border-color:  #2673E5;
          background: #2673E5;
          color: #fff;
        }
        &.dis{
          border: 1px solid #aaaaaa;
        }
        &.ckd.dis{
          border-color:  #aaaaaa;
          background: #aaaaaa;
        }
      }
        
      .option-text {
        font-size: 14px;
      }
      .score-box{
        display: flex;
        align-items: center;
        margin-left: 8px;
        .score-label{
          font-size: 12px;
          color: #808080;
          margin-right: 8px;
        }
      }
    }
    ::v-deep .el-textarea {
      width: 100%;
      .el-textarea__inner {
        width: 100%;
        line-height: 22px;
      }
      .el-input__count {
        right: 10px;
        bottom: 2px;
        font-size: 12px;
        color: #808080;
        background: transparent;
        line-height: 20px;
        height: 20px;
      }
    }
  }
}
</style> 